module.exports = __webpack_public_path__ + "c7a0aece36089a516fb3992aad90b5fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-2.png
// module id = 3003
// module chunks = 0